import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import Debug from 'debug';
import Fluxible from 'fluxible';
import qs from 'qs';
import {createElementWithContext} from 'fluxible-addons-react';
import {navigateAction} from 'fluxible-router';
import env from './config/client';
import Banquet from './components/Banquet';
import DelectoryApiPlugin from './plugins/DelectoryApiPlugin';
import ExperimentsPlugin from './plugins/ExperimentsPlugin';
import UserAgentPlugin from './plugins/UserAgentPlugin';
import AnalyticsPlugin from './plugins/AnalyticsPlugin';
import BanquetRouteManagerPlugin from './plugins/BanquetRouteManagerPlugin';
import BookmarkStore from './stores/BookmarkStore';
import CollectionStore from './stores/CollectionStore';
import CustomerStore from './stores/CustomerStore';
import InventoryRecordStore from './stores/InventoryRecordStore';
import OrderStore from './stores/OrderStore';
import RouteStore from './stores/RouteStore';
import ShoppingCartStore from './stores/ShoppingCartStore';
import StoreStore from './stores/StoreStore';
import WineSkuStore from './stores/WineSkuStore';

Debug.enable('delectable, FluxibleApp, client, Routr:*, navigateAction');

function App(options) {
  options = options || {};
  _.defaults(options, {authCredentials: {sk: null, st: null, dismiss_cookies: false}});
  let sessionKey = options.authCredentials.sk;
  let sessionToken = options.authCredentials.st;
  let dismissCookies = options.authCredentials.dismiss_cookies;
  const app = new Fluxible({
    component: Banquet
  });
  const delectoryApiPlugin = new DelectoryApiPlugin({
    baseUrl: env.ApiBaseUrl,
    sessionKey: sessionKey,
    sessionToken: sessionToken,
    dismissCookies: dismissCookies,
    req: options.req // server-side only
  });
  app.plug(new UserAgentPlugin());
  app.plug(new ExperimentsPlugin({req: options.req}));
  app.plug(new AnalyticsPlugin({host: options.req ? options.req.get('host') : window.location.host}));
  app.plug(new BanquetRouteManagerPlugin({store: options.req ? options.req.currentStore : null}));
  app.plug(delectoryApiPlugin);
  app.registerStore(BookmarkStore);
  app.registerStore(CollectionStore);
  app.registerStore(CustomerStore);
  app.registerStore(InventoryRecordStore);
  app.registerStore(OrderStore);
  app.registerStore(RouteStore);
  app.registerStore(ShoppingCartStore);
  app.registerStore(StoreStore);
  app.registerStore(WineSkuStore);
  return app;
}

export default App;



// WEBPACK FOOTER //
// banquet/app.js